/**
 * PV Press Mentions
 * Drives the mobile prev/next arrows for the horizontal scroll-snap
 * carousel (the shared gradient bar takes over at 768px, where the
 * arrows are hidden by CSS).
 *
 * Arrows scroll to an absolute card index (not a relative scrollBy) so fast
 * taps on iOS Safari can't stack onto a half-finished smooth scroll and
 * fight the scroll-snap.
 */

(function () {
  'use strict';

  document.querySelectorAll('.pv-press-mentions__nav').forEach(function (nav) {
    var track = nav.previousElementSibling;
    if (!track) return;

    var prevBtn = nav.querySelector('[data-scroll-prev]');
    var nextBtn = nav.querySelector('[data-scroll-next]');

    var targetIndex = null;
    var settleTimer = null;

    function cards() {
      return Array.prototype.slice.call(track.children);
    }

    function cardLeft(card) {
      return card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function currentIndex() {
      var list = cards();
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < list.length; i++) {
        var dist = Math.abs(cardLeft(list[i]) - track.scrollLeft);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function updateButtons() {
      var max = maxScroll();
      var left = targetIndex === null
        ? track.scrollLeft
        : Math.min(cardLeft(cards()[targetIndex]), max);
      prevBtn.disabled = left <= 1;
      nextBtn.disabled = left >= max - 1;
    }

    function goTo(index) {
      var list = cards();
      if (!list.length) return;
      targetIndex = Math.max(0, Math.min(list.length - 1, index));
      var left = Math.min(cardLeft(list[targetIndex]), maxScroll());
      track.scrollTo({ left: left, behavior: 'smooth' });
      updateButtons();
    }

    function step(dir) {
      var base = targetIndex === null ? currentIndex() : targetIndex;
      goTo(base + dir);
    }

    prevBtn.addEventListener('click', function () { step(-1); });
    nextBtn.addEventListener('click', function () { step(1); });

    // iOS < 17 has no `scrollend`: treat the scroll as settled once it goes quiet.
    track.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        targetIndex = null;
        updateButtons();
      }, 120);
      if (targetIndex === null) updateButtons();
    }, { passive: true });

    window.addEventListener('resize', function () {
      targetIndex = null;
      updateButtons();
    });
    updateButtons();
  });
})();
